var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _circle2, _path13, _path14, _path15, _path16, _path17, _circle3, _circle4, _path18, _path19, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 753.9 703.8",
    style: {
      enableBackground: "new 0 0 753.9 703.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E6E6E6;}\n\t.st3{fill:#FFC600;}\n\t.st4{fill:#2F2E41;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.4,5.9l-23.1,12.6l-284.2,155L25,186.1c-23.3,12.8-31.9,42-19.2,65.3l211.6,387.9 c12.8,23.3,42,31.9,65.3,19.2h0.1L613,478.3h0.1c23.3-12.8,31.9-42,19.2-65.3L420.7,25.1C408,1.8,378.7-6.8,355.4,5.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362,18l-27.3,14.9L59,183.4l-27.3,14.9C15.1,207.4,9,228.2,18,244.8l211.6,387.9c9.1,16.6,29.9,22.7,46.5,13.7 h0.1l330.2-180.2h0.1c16.6-9.1,22.7-29.9,13.7-46.5l-211.7-388C399.5,15.1,378.7,9,362,18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.6,138.4l-123.2,67.2c-3.9,2.1-8.8,0.7-10.9-3.2s-0.7-8.8,3.2-10.9l0,0l123.2-67.2 c3.9-2.1,8.8-0.7,10.9,3.2C371.9,131.4,370.5,136.3,366.6,138.4L366.6,138.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.6,146.3l-152.2,83c-3.9,2.1-8.8,0.7-10.9-3.2s-0.7-8.8,3.2-10.9l0,0l152.2-83c3.9-2.1,8.8-0.7,10.9,3.2 C413.9,139.4,412.5,144.2,408.6,146.3L408.6,146.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.8,177.7l-113.5,62c-1.9,1-2.5,3.3-1.5,5.2l48.4,88.6c1,1.9,3.3,2.5,5.2,1.5l113.5-62 c1.9-1,2.5-3.3,1.5-5.2L198,179.2C197,177.3,194.7,176.6,192.8,177.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.7,250.9l-167,91.1c-3.9,2.1-8.8,0.7-10.9-3.2s-0.7-8.8,3.2-10.9l0,0l167-91.1c3.9-2.1,8.8-0.7,10.9,3.2 S431.6,248.8,427.7,250.9L427.7,250.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.7,258.8l-196.1,107c-3.9,2.1-8.8,0.7-10.9-3.2s-0.7-8.8,3.2-10.9l0,0l196.1-107c3.9-2.1,8.8-0.7,10.9,3.2 C475,251.8,473.6,256.7,469.7,258.8L469.7,258.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 197,
    cy: 382.7,
    r: 34
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M705.7,165.7H329.4c-26.6,0-48.1,21.6-48.1,48.1v441.9c0,26.6,21.6,48.1,48.1,48.1h376.3 c26.6,0,48.1-21.6,48.1-48.1V213.8C753.8,187.3,732.3,165.7,705.7,165.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M705.8,179.6H329.4c-18.9,0-34.2,15.4-34.3,34.3v441.9c0,18.9,15.4,34.2,34.3,34.3h376.3 c18.9,0,34.2-15.4,34.3-34.3v-442C740,194.9,724.7,179.6,705.8,179.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652.1,287.4H511.8c-4.4,0-8-3.6-8-8s3.6-8,8-8h140.3c4.4,0,8,3.6,8,8S656.5,287.4,652.1,287.4L652.1,287.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M685.1,314.5H511.8c-4.4,0-8-3.6-8-8s3.6-8,8-8h173.4c4.4,0,8,3.6,8,8C693.2,310.9,689.6,314.5,685.1,314.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M480.7,238.6H351.4c-2.1,0-3.8,1.7-3.8,3.8v101c0,2.1,1.7,3.8,3.8,3.8h129.4c2.1,0,3.8-1.7,3.8-3.8v-101 C484.6,240.3,482.9,238.6,480.7,238.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 415.1,
    cy: 292.9,
    r: 33.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M386.5,347.3c4-2.5,8.3-4.5,12.9-5.9c-0.4-1.5-0.4-3.2,0-4.7c1.2-4,5-6.7,9.1-6.6h13c4.2-0.1,7.9,2.6,9.2,6.6 c0.4,1.5,0.5,3.2,0,4.7c4.5,1.4,8.9,3.4,12.9,5.9H386.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M651.9,415.4H461.6c-4.4,0-8-3.6-8-8s3.6-8,8-8h190.3c4.4,0,8,3.6,8,8S656.3,415.4,651.9,415.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M684.9,442.5H461.6c-4.4,0-8-3.6-8-8s3.6-8,8-8H685c4.4,0,8,3.6,8,8C692.9,438.9,689.4,442.5,684.9,442.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M651.9,512.6H461.6c-4.4,0-8-3.6-8-8s3.6-8,8-8l0,0h190.3c4.4,0,8,3.6,8,8C659.9,509,656.3,512.6,651.9,512.6 L651.9,512.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M684.9,539.7H461.6c-4.4,0-8-3.6-8-8s3.6-8,8-8H685c4.4,0,8,3.6,8,8C692.9,536.1,689.4,539.7,684.9,539.7z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 386.2,
    cy: 420.6,
    r: 34
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 386.2,
    cy: 518.6,
    r: 34
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M651.9,610.6H461.6c-4.4,0-8-3.6-8-8s3.6-8,8-8l0,0h190.3c4.4,0,8,3.6,8,8S656.3,610.6,651.9,610.6L651.9,610.6 z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M684.9,637.7H461.6c-4.4,0-8-3.6-8-8s3.6-8,8-8H685c4.4,0,8,3.6,8,8C692.9,634.1,689.4,637.7,684.9,637.7z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 386.2,
    cy: 616.6,
    r: 34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.3d0784ebd623f7cca60a8ff0b09a957a.svg";
export { ForwardRef as ReactComponent };